import { Outlet } from 'react-router-dom';

import { SlideCheckout } from '#client/components/GlobalComponents/SlideCheckout';
import SlideInPanelHandler from '#client/components/SlideInPanelHandler';

function GlobalComponents({ children }) {
  return (
    <>
      <SlideCheckout />
      <SlideInPanelHandler />
      {children || <Outlet />}
    </>
  );
}

export default GlobalComponents;
